import React, { useState, useEffect, useRef, react} from "react";
import Contact from "./style"
import SectionTitle from "./Components/SectionTitle"
import { Col, Container, Row } from "react-bootstrap"
import ReCAPTCHA from "react-google-recaptcha"
import Axios from "axios"

const ContactSection = (props) => {
  // const url = 'http://diasol.uz/api/v1/applications/'
  const [dataVerified, setVerified] = useState(false)
  const [isPending, setIsPending] = useState(false)

  const [data, setData] = useState({
    full_name: '',
    phone: '+998',
    course: 1
  })

  function submit(e) {
    Axios.post('http://diasol.uz/api/v1/applications/', {
      full_name: data.full_name,
      phone: data.phone,
      course: parseInt(data.course),
    })
      .then(res => {
         console.log(res.data)
      })
      .catch(function(e){
        console.log(e)
      })
  }

  function handle(e) {
    const newData = { ...data }
    newData[e.target.id] = e.target.value
    setData(newData)
  }

  const recaptchaLoaded = () => {
    console.log('capcha successfully loaded')
  }

  const verifyCallback = (res) => {
    if (res) {
      setVerified(true)
      setIsPending(true)
    }
    else {
      setVerified(false)
      setIsPending(false)
    }
  }

  return (
    <Contact backgroundColor="#f3f4f6">
      <Container>
        <Row>
          <Col className="col-xl-7 col-lg-7">
            <Contact.Box>
              <SectionTitle
                subTitle="Регистрация"
                title="Запишитесь на курсы"
                text="Оставьте ваше имя и номер телефона и мы свяжемся с вами."
                subTitleProps={{ mb: "10px" }}
                titleProps={{ mb: "10px", as: "h2" }}
                mb="50px" />
            </Contact.Box>
            <Contact.From>
              <form onSubmit={(e) => submit(e)}>
                <Row>
                  <Col xs="12" className="col-lg-6 mb-4">
                    <div className="form-floating">
                      <input className="form-control" onChange={(e) => handle(e)} id="full_name" value={data.full_name} placeholder="name" type="text" />
                      <label htmlFor="floatinginput">Ваше имя</label>
                    </div>
                  </Col>
                  <Col xs="12" className="col-lg-6 mb-4">
                    <div className="form-floating">
                      <input className="form-control" type="phone" onChange={(e) => handle(e)} id="phone" value={data.phone} placeholder="date" />
                      <label htmlFor="floatinginput2">Номер телефона</label>
                    </div>
                  </Col>
                  <Col xs="12" className="col-lg-6 mb-4">
                    <div className="form-floating">
                      <select className="form-control" style={{borderRadius: '30px'}}
                              onChange={(e) => handle(e)} id="course" value={data.course} type="text">
                        <option value="1" selected>Frontend</option>
                        <option value="2">Backend</option>
                        <option value="3">Full-stack</option>
                      </select>
                      <label htmlFor="floatinginput3">Выберите Курс</label>
                    </div>
                  </Col>
                  <Col xs="12" className="col-lg-12">
                    <Row className="align-items-center mt-3">
                      <Col xs="12" className="col-lg-12 text-center justify-content-md-between py-3 d-md-flex"
                           style={{ alignItems: "center", }}>
                        <ReCAPTCHA sitekey="6Lfk0AIbAAAAAHe2JyGigIhehLs_WyYk9N1ZmjAW" render="explicit"
                                   onloadCallback={recaptchaLoaded} onChange={verifyCallback} className="mx-auton d-flex" />
                        { isPending && <Contact.Button type="submit">Отправить</Contact.Button>}
                        { !isPending && <Contact.Button disabled type="submit">Отправить</Contact.Button>}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </form>
            </Contact.From>
          </Col>
          <Col xs="12" className="col-xl-5 col-lg-5">
            <Contact.WidgetsBox className="contact-widget-box">
              <Contact.WidgetsBoxTitle as="h2">Наши контакты</Contact.WidgetsBoxTitle>
              {/* <Contact.WidgetsBoxText as="p">therefore always free from <br className="d-none d-xl-block" />  repetition, injected humour, or <br className="d-none d-xl-block" /> non-characteristic</Contact.WidgetsBoxText> */}
              <Row>
                <Col xs="12" className="col-lg-12 col-sm-6">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon>
                      <i className="fas fa-envelope" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Электронная почта:</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">info@nextgen.uz</Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
                <Col xs="12" className="col-lg-12 col-sm-6 active">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon className="active">
                      <i className="fas fa-phone-alt" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Телефон:</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">+998 (95) 680-77-77</Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
                <Col xs="12" className="col-lg-12 col-sm-6">
                  <Contact.Widgets>
                    <Contact.WidgetsIcon>
                      <i className="fas fa-map-marker-alt" />
                    </Contact.WidgetsIcon>
                    <Contact.WidgetsBoxBody>
                      <Contact.WidgetsTitle as="h3">Адрес:</Contact.WidgetsTitle>
                      <Contact.WidgetsText as="p">
                        <span>Самарканд, ул М. Аль-Хорезми, 113<br className="d-block" />
                        Бизнес центр, эт.5<br className="d-block" /></span>
                      </Contact.WidgetsText>
                    </Contact.WidgetsBoxBody>
                  </Contact.Widgets>
                </Col>
              </Row>
            </Contact.WidgetsBox>
          </Col>
        </Row>
      </Container>
    </Contact>
  )
}

export default ContactSection